export enum PDFStatus {
  ready = "ready",
  loading = "loading",
  pending = "pending",
  missingData = "missingData",
}

export enum DocType {
  risk = "risk",
  plate = "plate",
  manual = "manual",
  conformity = "conformity",
  standardList = "standardList",
  directiveList = "directiveList",
  exitConformity = "exitConformity",
  exitConformity_emv = "exitConformity_emv",
  exitConformity_lvd = "exitConformity_lvd",
  exitConformity_mrl = "exitConformity_mrl",
  exitConformity_mvo = "exitConformity_mvo",
  installationConformity = "installationConformity",
}

export enum ImageType {
  riskImage = "risk_image",
  manufacturerLogo = "manufacturer_logo",
  mainProductImage = "main_product_image",
}

export enum SpecialUploadType {
  detailedDescription = "detailed_description",
}

export type UploadType = ImageType | DocType | SpecialUploadType;
